import DIApi from './_diApi';

class AssetCategoryAPI extends DIApi {
  controllerName = 'AssetCategorys';
}

export default new AssetCategoryAPI();
